import { Directive, OnDestroy } from '@angular/core';
import { LayoutModeType, MenuMode } from '@osos/shared/types';
import { ReplaySubject } from 'rxjs';
import {
  BASE_LAYOUT,
  BASE_MENU,
  FONT_BASE_SIZE,
  FONT_SCALES,
  MENU_MODES,
} from '../../const';

@Directive()
export class BaseUiThemeDirective implements OnDestroy {
  destroy$ = new ReplaySubject<void>(1);

  fontScale = FONT_BASE_SIZE;
  fontScales = FONT_SCALES;
  menuModes = MENU_MODES;
  menuMode: MenuMode = BASE_MENU;
  layoutMode: LayoutModeType = BASE_LAYOUT;

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
